import * as React from 'react';
import { IconType } from 'react-icons/lib';
import { Button } from './button';
import styles from './button-input-group.scss';
export interface ButtonInputGroupProps {
  icon: IconType;
  onClick?: (event: any) => void;
  disabled?: boolean;
  callToAction?: boolean;
  className?: string;
}

export const ButtonInputGroup : React.FC<ButtonInputGroupProps> = props => (
      <Button
        icon={props.icon}
        onClick={props.onClick}
        btnType="button-input-group"
        classNames={`${styles.btnInputGroup}
          ${props.callToAction ? styles.callToActionStyling : ''}
          ${props.className ? props.className : ''}`}
        disabled={props.disabled}
      />
);

ButtonInputGroup.displayName = 'ButtonInputGroup';
